<template>
  <div
    class="tag-container d-flex flex-column gap-xxs align-items-start"
    :class="size">
    <StyleColorHistoryTag
      :style-color="styleColor"
      :style-color-source="styleColorSource"
      :style-color-source-index="styleColorSourceIndex"
      :size="size"/>
    <StyleColorStarRatingTag
      :style-color="styleColor"
      :style-color-source="styleColorSource"
      :style-color-source-index="styleColorSourceIndex"
      :size="size"/>
  </div>
</template>

<script setup>
import StyleColorHistoryTag from '@shared/components/ADORN/StyleColorHistoryTag.vue'
import StyleColorStarRatingTag from './StyleColorStarRatingTag.vue'

defineProps({
  styleColor: {
    type: Object,
    required: true
  },
  /** @type {PropType<StyleColorSource>} */
  styleColorSource: {
    type: Object,
    required: true
  },
  styleColorSourceIndex: {
    type: Number,
    default: () => null
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  }
})

</script>

<style lang="scss" scoped>
@import './StyleColorQuickActions.scss';
</style>
